import script from "./SkuHistoryNameGroupList.vue?vue&type=script&setup=true&lang=js"
export * from "./SkuHistoryNameGroupList.vue?vue&type=script&setup=true&lang=js"

import "./SkuHistoryNameGroupList.vue?vue&type=style&index=0&id=6f004e66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f004e66"]])

export default __exports__